import { useMemo } from 'react';
import useLayout from '@/use/useLayout';
import useBoard from '@/use/useBoard';
import { useWindowSize } from '@react-hook/window-size';

import { gridWidth, gridHeight } from '@/constants';

const useGrid = () => {
  const [ww] = useWindowSize();
  const board = useBoard();
  const { layout } = useLayout();
  const padding = layout === 'desktop' ? 40 : 0;

  const minimumSideWidth = useMemo(() => {
    if (ww < 600) {
      return 120;
    }

    if (ww < 700) {
      return 140;
    }

    return 160;
  }, [ww]);

  const minimumSideHeight = 110;

  const boundaries = useMemo(() => {
    if (layout === 'portrait') {
      return {
        width: board.width - padding,
        height: board.height - padding - minimumSideHeight * 2,
      };
    }

    return {
      width: board.width - padding - minimumSideWidth * 2,
      height: board.height - padding,
    };
  }, [layout, board.width, board.height]);

  const scale = Math.min(
    Math.min(boundaries.width / gridWidth, boundaries.height / gridHeight, 1),
  );

  const width = gridWidth * scale;
  const height = gridHeight * scale;

  const x = -width / 2;
  const y = -height / 2;

  return {
    scale,
    x,
    y,
    width,
    height,
  };
};

export default useGrid;
